<template>
  <div>
    <NavigationBar titel="Buchhaltung" isPreview></NavigationBar>
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
export default {
  name: "finance-bookkeeping",
  components: {
    NavigationBar,
  },
};
</script>
